<template>
  <div class="edit-studio-container">
    <main class="tab-content">
      <h2 class="item text-secondary">Locator with map content:</h2>
      <div class="btn-container">
        <span id="cancelUser" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_user_info">
        <div class="field-sec" v-if="fit20.selectedTabHref != 'country'">
          <label>Title:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.locator_title" />
        </div>
        <div class="field-sec" v-if="fit20.selectedTabHref != 'country'">
          <label>Subtitle:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.locator_sub_title" />
        </div>
        <div class="field-sec">
          <label>Search placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.locator_search_field" />
        </div>
        <div class="field-sec">
          <label>Zoom:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.zoom" />
        </div>
        <div class="field-sec">
          <label>Map Longitude:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.map_center.lng" />
        </div>
        <div class="field-sec">
          <label>Map Latitude:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.map_center.lat" />
        </div>
      </form>
      <div class="btn-container">
        <span id="cancelUser2" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser2" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <br>
      <h3 class="text-secondary">Example:</h3>
      The example is for testing the content but may not be functional:
      <br>
      <div class="locator-container" id="locator_container">
        <h2 class="locator-title" v-if="fit20.blockToEdit.locator_title">{{ fit20.blockToEdit.locator_title }}</h2>
        <div class="locator-subtitle" v-if="fit20.blockToEdit.locator_sub_title">{{ fit20.blockToEdit.locator_sub_title
        }}</div>
        <div class="locator-content-container">
          <div class="locator-search-section-with-map">
            <div class="locator-search-section">
              <div class="locator-search-box">
                <input id="search_field" class="locator-search-field" type="search"
                  :placeholder="fit20.blockToEdit.locator_search_field" />
                <i id="search_icon_locator" class="fa fa-fw fa-search" onclick="" style="font-size: 20px"></i>
              </div>
            </div>
          </div>
          <div class="locator-left-sec locator-left-sec-with-map">
            <div id="map"></div>
          </div>
          <div class="address-container address-container-with-map">
            <div id="locator_address">
              <a class="address-item" href="#">
                <div>
                  <img loading="lazy" src="https://www.fit20.com/files/locator/img/UK/placeholder.jpg" alt="" />
                  <div class="address-info-text not-fixed">
                    <div class="address-studio-name">fit20 example 1</div>
                    <div class="studio-info stronger">address 1<br />
                      post Code 1<br />
                      000000000
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class="btn-container">
        <span id="cancelUser3" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser3" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  name: 'LocatorWithMap',
  props: ["fit20", "saveBlock", "cancelEditing"],
  data() {
    return { map: null, }
  },
  mounted() {
    var gtmScript = document.createElement('script');
    gtmScript.setAttribute(
      'src',
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyAS8KXAUJWTDN3mTBynyPKvyst2itC6Ku8&callback=initMap&libraries=geometry',
    );
    gtmScript.setAttribute('defer', true);
    document.head.appendChild(gtmScript);

  },
  created() {
    const mapStyle = [
      {
        featureType: 'administrative',
        elementType: 'all',
        stylers: [
          {
            saturation: '-100',
          },
        ],
      },
      {
        featureType: 'administrative.province',
        elementType: 'all',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [
          {
            saturation: -100,
          },
          {
            lightness: 65,
          },
          {
            visibility: 'on',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'all',
        stylers: [
          {
            saturation: -100,
          },
          {
            lightness: '50',
          },
          {
            visibility: 'simplified',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'all',
        stylers: [
          {
            saturation: '-100',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'all',
        stylers: [
          {
            visibility: 'simplified',
          },
        ],
      },
      {
        featureType: 'road.arterial',
        elementType: 'all',
        stylers: [
          {
            lightness: '30',
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'all',
        stylers: [
          {
            lightness: '40',
          },
        ],
      },
      {
        featureType: 'transit',
        elementType: 'all',
        stylers: [
          {
            saturation: -100,
          },
          {
            visibility: 'simplified',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          {
            hue: '#acbcc9',
          },
          {
            lightness: -25,
          },
          {
            saturation: -97,
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels',
        stylers: [
          {
            lightness: -25,
          },
          {
            saturation: -100,
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          {
            color: '#acbcc9',
          },
          {
            lightness: 17,
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [
          {
            color: '#f5f5f5',
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 17,
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 29,
          },
          {
            weight: 0.2,
          },
        ],
      },
      {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 18,
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
          {
            color: '#f5f5f5',
          },
          {
            lightness: 21,
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
          {
            color: '#dedede',
          },
          {
            lightness: 21,
          },
        ],
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [
          {
            visibility: 'on',
          },
          {
            color: '#ffffff',
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        elementType: 'labels.text.fill',
        stylers: [
          {
            saturation: 36,
          },
          {
            color: '#333333',
          },
          {
            lightness: 40,
          },
        ],
      },
      {
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [
          {
            color: '#f2f2f2',
          },
          {
            lightness: 19,
          },
        ],
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#fefefe',
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#fefefe',
          },
          {
            lightness: 17,
          },
          {
            weight: 1.2,
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          {
            color: '#021019',
          },
          {
            lightness: 88,
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [
          {
            color: '#f5f5f5',
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 17,
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 29,
          },
          {
            weight: 0.2,
          },
        ],
      },
      {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 18,
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
          {
            color: '#f5f5f5',
          },
          {
            lightness: 21,
          },
        ],
      },
    ];
    const vm = this;
    let center = { lat: parseFloat(this.fit20.blockToEdit.map_center.lat), lng: parseFloat(this.fit20.blockToEdit.map_center.lng) }
    window.initMap = async function () {

      // console.log(vm.fit20.blockToEdit.map_center);
      // console.log(vm.fit20.blockToEdit.zoom);
      // Create a map object and specify the DOM element for display.
      vm.map = new google.maps.Map(document.getElementById('map'), {
        center: center,
        zoom: parseFloat(vm.fit20.blockToEdit.zoom),
        styles: mapStyle,
        streetViewControl: false,
        mapTypeControl: false,
      });
    }
  },
  watch: {
    "fit20.blockToEdit.map_center": {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        console.log(newVal);
        console.log(this.map);
        this.map.setCenter({ lat: parseFloat(newVal.lat), lng: parseFloat(newVal.lng) })
      }
    },
    "fit20.blockToEdit.zoom": {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        console.log(newVal);
        console.log(this.map);
        if (newVal && parseFloat(newVal)) {
          this.map.setZoom(parseFloat(newVal));
        }

      }
    },
  }
};
</script>

<style scoped>
.edit-studio-container {
  width: 100%;
  overflow: auto;
}

.tab-content {
  padding-top: 15px;
}

.tab-content h2 {
  margin-left: 10px;
}

.img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.form-container div {
  width: calc(100% / 2 - 30px);
}

.form-container label {
  display: block;
}

.studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.users-col {
  width: calc(100%);
}

.studio-machines {
  width: 100%;
}

.ex-member-container {
  margin-top: 10px;
}

.ex-member-flex {
  width: 100% !important;
}

.ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.ex-member-container img {
  margin-bottom: 7px;

}

.measure-div {
  position: relative;
}

.kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}

/* example css */
.locator-container {
  max-width: 1500px;
  background-color: #009fe31f;
  padding-top: 30px;
}

.locator-content-container {
  display: flex !important;
  flex-wrap: wrap;
  max-width: 1500px;
  margin: 0 auto;
}

.locator-left-sec {
  width: 40% !important;
  margin: auto;
  text-align: center;
}

.locator-left-sec-with-map {
  width: 45% !important;
}

#map {
  height: 560px;
}

#locator_address {
  display: flex !important;
  flex-wrap: wrap !important;
  width: 100%;
}

.address-container {
  width: 50% !important;
  margin: 0 auto;
  height: 560px;
  overflow-y: scroll;
  margin-top: 30px;
  margin-bottom: 30px;
  max-width: 650px !important;
}

.locator-subtitle {
  text-align: center;
  width: 90%;
  margin: 0 auto;
}

.locator-title,
.address-studio-name {
  font-family: 'VAG Rounded Std light', Verdana, Tahoma, sans-serif !important;
}

.locator-search-btn,
.show-all-studios,
.address-item-btn {
  font-family: 'VAG Rounded Std light light', Verdana, Tahoma, sans-serif !important;
}

.address-container img {
  width: 100% !important;
  height: 155px !important;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.locator-title {
  text-align: center !important;
  color: #009df4 !important;
}

.locator-search-section {
  max-width: 400px;
  margin: 0 auto;
  margin-top: 30px;
  background-color: white;
  border-radius: 30px;
  height: 30px;
}

.locator-search-section-with-map {
  width: 100%;
}

.locator-search-box {
  background-color: #ffffff !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  border: solid 1px #494b5326 !important;
  border-radius: 30px;
  height: 30px;
}

.locator-search-field {
  width: 90% !important;
  font-size: 15px !important;
  border: none !important;
  padding: 15px 0 15px 10px !important;
  background-color: transparent !important;
  color: #494b53 !important;
  outline: none !important;
  border-radius: 30px;
  background-color: white;
}

.locator-search-box i {
  color: #009df4 !important;
  padding-right: 10px !important;
  cursor: pointer;
}

.locator-search-section select {
  width: 20% !important;
  text-align: center !important;
  font-size: 15px !important;
}

.locator-search-section select,
.locator-search-section .locator-search-btn {
  color: #494b53 !important;
  outline: none !important;
  border: none !important;
  margin-left: 5px !important;
}

.locator-search-section .locator-search-btn {
  background-color: #009fe3 !important;
  color: white !important;
  font-size: 18px !important;
  padding: 0 15px !important;
  width: auto !important;
}

.show-all-studios-div {
  margin-top: 30px;
}

a.show-all-studios {
  text-align: center !important;
  padding: 8px 15px !important;
  color: #009df4 !important;
  background-color: white;
  font-size: 14px !important;
  border: solid 1px #009df4;
  border-radius: 20px;
  transition: color 0.5s, background-color 0.5s;
}

.locator-left-sec a:link,
.locator-left-sec a:active,
.locator-left-sec a:visited {
  color: #009df4 !important;
  background-color: white;
  text-decoration: none !important;
}

.locator-left-sec a:hover {
  color: white !important;
  background-color: #009fe3;
  text-decoration: none !important;
}

.address-item {
  width: calc(100% / 2 - 30px) !important;
  text-align: center;
  border-radius: 10px;
  background-color: white;
  margin: 0px 25px 25px 0px;
  display: block;
  max-width: 265px;
  max-height: 300px;
  min-height: 250px;
}

.address-container::-webkit-scrollbar {
  width: 10px;
}

.address-container::-webkit-scrollbar-track {
  background: transparent !important;
  border-radius: 20px;
  box-shadow: inset 7px 0px 0px #0000002b;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
}

.address-container::-webkit-scrollbar-thumb {
  background-color: #92d400;
  border-radius: 20px;
  border: 3px solid transparent;
  background-clip: padding-box;
}

.address-item:hover {
  box-shadow: 0 0 10px 0 gray !important;
}

.address-studio-name {
  font-size: 20px !important;
  color: #92d400;
}

.address-info-text {
  padding: 10px !important;
  font-size: 13px !important;
}

.studio-info {
  font-size: 14px !important;
  color: #616365 !important;
  /* padding-top: 10px; */
  line-height: normal;
}

.address-item-btn {
  background-color: #009fe3 !important;
  text-align: center !important;
  padding: 10px 5px !important;
  position: absolute !important;
  width: 100% !important;
  display: block !important;
  z-index: 1 !important;
  margin: 0 auto !important;
  bottom: -40px !important;
}

.address-container a:link,
.address-container a:active,
.address-container a:visited,
.address-container a:hover {
  color: rgb(105, 105, 105) !important;
  text-decoration: none !important;
}

.address-item-btn:after {
  transition: all 0.5s !important;
  content: '' !important;
  background: #92d400 !important;
  width: 0% !important;
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  height: 100% !important;
  z-index: -1 !important;
}

.distance {
  text-align: right !important;
  padding: 3px 0 !important;
}

.span-distance {
  border: 1px solid !important;
  padding: 3px 6px !important;
}

@media only screen and (max-width: 1180px) {
  .address-container {
    height: 540px !important;
  }

  #map {
    height: 530px !important;
  }
}

@media only screen and (max-width: 850px) {
  .address-container {
    width: 60% !important;
  }

  .address-container-with-map {
    width: 50% !important;
  }

  .locator-title {
    font-size: 25px !important;
  }
}

@media only screen and (max-width: 650px) {
  .locator-content-container:nth-child(1) {
    order: 1;
  }

  .locator-left-sec-with-map:nth-child(2) {
    order: 3;
  }

  .locator-content-container:nth-child(3) {
    order: 2;
  }

  .locator-container {
    padding-left: 20px;
  }

  .address-container {
    height: 300px !important;
  }

  .address-item {
    width: calc(85% - 20px) !important;
    margin: 6px auto;
  }

  .locator-left-sec-with-map {
    width: 100% !important;
  }

  #map {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 95% !important;
    height: 350px !important;
  }

  .locator-container-with-map {
    padding-left: 20px;
  }

  .address-container-with-map {
    width: 90% !important;
  }

  .address-container-with-map {
    height: 265px;
  }

  .address-item-with-map {
    width: calc(85% - 20px) !important;
    margin: 6px auto;
  }

  .locator-title {
    font-size: 20px !important;
  }
}
</style>
